import { render, staticRenderFns } from "./DeactivateDialog.vue?vue&type=template&id=7012edaa&scoped=true&"
import script from "./DeactivateDialog.vue?vue&type=script&lang=js&"
export * from "./DeactivateDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeactivateDialog.vue?vue&type=style&index=0&id=7012edaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7012edaa",
  null
  
)

export default component.exports